import './FeatureProductMultiVariantAddToCart.less';
import useAppDispatch from '../../../hooks/useAppDispatch';
import useAppSelector from '../../../hooks/useAppSelector';
import MultiProductVariantPicker from '../../product/variant-picker/MultiProductVariantPicker';
import AddToCartFinished from './AddToCartFinished';
import ProductSuggestionsPanel from '../common/ProductSuggestionsPanel';
import { useTranslation } from '../../../hooks/useTranslation';

const FeatureProductMultiVariantAddToCart = () => {
    const { t } = useTranslation();
    const mainFeatureItem = useAppSelector(
        state => state.featureState.mainFeatureItem
    );

    if (mainFeatureItem?.featureType !== 'product-multi-variant-add-to-cart') {
        return null;
    }

    const dispatch = useAppDispatch();
    const { addingToCartStatus } = useAppSelector(state => state.cartState);
    const hasFinished =
        addingToCartStatus === 'success' || addingToCartStatus === 'error';

    return (
        <div
            className={`bri-FeatureProductMultiVariantAddToCart bri-SlimScroll ${
                hasFinished
                    ? 'bri-FeatureProductMultiVariantAddToCart-finished'
                    : ''
            }`}
        >
            {!hasFinished ? (
                <MultiProductVariantPicker
                    isLoading={addingToCartStatus === 'loading'}
                    products={mainFeatureItem.products}
                    onAccept={selectedVariants =>
                        Promise.all([
                            dispatch.cartState.addMultiVariantToCart(
                                selectedVariants
                            ),
                            dispatch.featureState.loadSuggestedProductsAfterMultiVariantAddToCartSuccess(
                                mainFeatureItem.products
                            )
                        ])
                    }
                    onRemove={productId =>
                        dispatch.featureState.removeProductFromMultiVariantAddToCart(
                            productId
                        )
                    }
                />
            ) : (
                <>
                    <AddToCartFinished
                        addingToCartStatus={addingToCartStatus}
                        addingProducts={mainFeatureItem.products}
                    />
                    <ProductSuggestionsPanel
                        suggestions={[
                            {
                                title: t('PRODUCTS_SUGGESTED_TITLE'),
                                description: t('PRODUCTS_SUGGESTED_SUBTITLE'),
                                products: mainFeatureItem.suggestedProducts
                            }
                        ]}
                        featureType="product-search-similar"
                    />
                </>
            )}
        </div>
    );
};

export default FeatureProductMultiVariantAddToCart;
